import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { ResetPasswordAction, SetAuthLoading } from '../store/auth.actions';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  newPasswordForm!: FormGroup;
  newPasswordVisible: boolean = false;
  confirmPasswordVisible: boolean = false;
  token!: string

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private activateRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    localStorage.removeItem('currentUser');
    this.newPasswordForm = this.fb.group({
      new_password: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?!.*\s$)(?!^\s)(?=.*[A-Za-z])(?=.*\d).{8,}$/
          ),
        ],
      ],
      confirm_password: ['', [Validators.required]]
    }, { validator: this.passwordMatcher });

    this.token = this.activateRoute.snapshot.paramMap.get('token')!;
  }

  passwordMatcher(formGroup: FormGroup) {
    const newPassword = formGroup.get('new_password')?.value;
    const confirmPassword = formGroup.get('confirm_password')?.value;
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      formGroup.get('confirm_password')?.setErrors({ mismatch: true });
    } else {
      formGroup.get('confirm_password')?.setErrors(null);
    }
  }

  resetPassword(): boolean {
    if (!this.newPasswordForm.valid) {
      this.newPasswordForm.markAllAsTouched();
      return false;
    }

    const { new_password, confirm_password } = this.newPasswordForm.value;
    this.store.dispatch(SetAuthLoading({ isLoading: true }));
    this.store.dispatch(ResetPasswordAction({ payload: { newPassword: new_password, confirm_password, token: this.token } }));

    return true;
  }

  /**
   * `ui-form-field` calls `preventDefault()` on Enter, which also suppresses the
   * browser's implicit form submission — so submit explicitly. Scoped to inputs:
   * a button already turns Enter into a click, and letting this run there would
   * dispatch the reset twice.
   */
  onEnterKey(event: Event): void {
    if ((event.target as HTMLElement | null)?.tagName === 'INPUT') {
      this.resetPassword();
    }
  }
}
